module.exports = __webpack_public_path__ + "img/pazar-asnaf.c0c9c54a.jpg";